import React from "react";
import { Link } from "react-router-dom";
import { FontIcon } from "@fluentui/react";
import { Checkbox, MessageBar, MessageBarBody } from "@fluentui/react-components";
import {
  Attachment as AttachmentType,
  AttachmentComparison,
  MessageBarType as ServerMessageBarType,
} from "../../../../types/messages";
import AttachmentIcon from "../AttachmentIcon";
import {
  wrapperClasses,
  asideClasses,
  bodyClasses,
  descriptionClasses,
  changesSummaryClasses,
  changesSummaryWrapperClasses,
  saveStackClasses,
} from "./style";
import {isAttachmentComparisonType, isAttachmentType, stripNbsp} from "../../../../utils";
import useAppContext from "../../../../hooks/useAppContext";
import { SaveCheckboxType } from "../../../../containers/AppContainer/AppContainer";
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import useAuthContext from "../../../../hooks/useAuthContext";
import { NO_DOC_MANAGEMENT } from "../../../../config";

type Props = {
  attachment: AttachmentType | AttachmentComparison;
};

const Attachment: React.FC<Props> = (props) => {
  const { attachment } = props;
  const { isSaving, addCheck, unCheck, isChecked, getCheckboxLabel } = useAppContext();
  const appInsights = useAppInsightsContext();
  const { appInfo } = useAuthContext();

  const getMessageBarIntent = (type: ServerMessageBarType): "info" | "error" | "warning" | "success" => {
    switch (type) {
      case "info": return "info";
      case "error": return "error";
      case "blocked": return "error";
      case "severeWarning": return "warning";
      case "success": return "success";
      case "warning": return "warning";
    }
  };

  const getCheckbox = (type: SaveCheckboxType) => {
    let disabled = false;

    if (type === "compareNewDocument") {
      disabled = isChecked({ id: attachment.attachmentId, type: "compare" });
    }

    if (type === "compare") {
      disabled = isChecked({ id: attachment.attachmentId, type: "compareNewDocument" });
    }

    return (
      <Checkbox
        label={getCheckboxLabel(type)}
        disabled={isSaving || disabled}
        checked={isChecked({ id: attachment.attachmentId, type: type })}
        onChange={(_, data) => {
          if (data.checked) {
            addCheck({ id: attachment.attachmentId, type: type });
          } else {
            unCheck({ id: attachment.attachmentId, type: type });
          }
        }}
      />
    );
  };

  return (
    <div className={wrapperClasses}>
      <div className={asideClasses}>
        <AttachmentIcon size={20} type={attachment.attachmentType} />
      </div>
      <div className={bodyClasses}>
        <div>{attachment.attachmentName}</div>
        {isAttachmentComparisonType(attachment) && (
          <>
            {attachment.comparisonSummary && (
              <div className={descriptionClasses}>{stripNbsp(attachment.comparisonSummary)}</div>
            )}
            {attachment.changesSummary && (
              <div className={changesSummaryWrapperClasses}>
                <Link
                  to={`/changes-summary/${attachment.attachmentId}`}
                  className={changesSummaryClasses}
                  onClick={() => {
                    appInsights.trackEvent({ name: "View changes" });
                  }}
                >
                  <FontIcon
                    aria-label="BranchPullRequest"
                    iconName="BranchPullRequest"
                    style={{ fontSize: 14, marginRight: 7 }}
                  />{" "}
                  {attachment.changesSummary}
                </Link>
              </div>
            )}
            {attachment.messageBar && attachment.messageBarType ? (
              <div>
                <MessageBar intent={getMessageBarIntent(attachment.messageBarType)}>
                  <MessageBarBody>{stripNbsp(attachment.messageBar)}</MessageBarBody>
                </MessageBar>
              </div>
            ) : null}
            {appInfo.documentManagement !== NO_DOC_MANAGEMENT && (
              <div className={saveStackClasses}>
                <div>Save</div>
                {/* <div>{getCheckbox("attach")}</div> */}
                {/* <div>{getCheckbox("new")}</div> */}
                <div>{getCheckbox("compare")}</div>
                <div>{getCheckbox("compareNewDocument")}</div>
              </div>
            )}
          </>
        )}
        {appInfo.documentManagement !== NO_DOC_MANAGEMENT && isAttachmentType(attachment) && <div>{getCheckbox("new")}</div>}
      </div>
    </div>
  );
};

export default Attachment;
